export default {
  summary_one: '{{count}} vare blev fjernet · ikke tilgængelig på dit afhentningstidspunkt',
  summary_other: '{{count}} varer blev fjernet · ikke tilgængelige på dit afhentningstidspunkt',
  reason: 'Kan kun bestilles {{schedule}} – din afhentning er kl. {{time}}.',
  change_pickup_time: 'Skift afhentningstid',
  dismiss: 'Afvis',
};
